<template>
  <v-dialog
    :value="value"
    @input="handleInput"
    max-width="500px"
  >
    <avs-card>
      <template v-slot:title>
        <v-card-title class="pa-0"> {{ $t("commons.close_title") }} </v-card-title>
      </template>
      <template v-slot:content>
        <v-card-text>
          {{ $t("commons.close_previous_question") }}
        </v-card-text>

        <v-card-actions class="d-flex justify-end gap-4">
          <avs-button
            color="blue white--text"
            iconI="mdi-check-circle-outline"
            noSpantext
            @click="handleConfirm"
          >
            <template v-slot:name>{{ $t("commons.close") }}</template>
          </avs-button>

          <avs-button
            color="success white--text"
            iconI="mdi-plus"
            noSpantext
            @click="handleCancel"
          >
            <template v-slot:name>{{ $t("commons.create_new_action") }}</template>
          </avs-button>
        </v-card-actions>
      </template>
    </avs-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CloseActionDialog",
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleInput(newValue) {
      this.$emit("input", newValue)
    },
    handleCancel() {
      this.$emit("cancel")
    },
    handleConfirm() {
      this.$emit("close_action")
    }
  }
}
</script>
